<template>
  <div class="container" id="header_id">
    <header>
      <p>Hi there, my name is</p>
      <h1>Faisal Amin.</h1>
      <h2>Full Stack Engineer.</h2>
      <p>
        Dedicated to problem-solving and innovation, I specialize in turning
        concepts into comprehensive Full Stack solutions for diverse
        applications.
      </p>
      <a
        class="get-in-touch"
        target="_blank"
        href="mailto:faysalamin001@gmail.com?subject=Hello%20Faisal&body=I%20would%20like%20to%20get%20in%20touch%20regarding..."
        >Get In Touch</a
      >
    </header>
  </div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style></style>
